<template>
  <div class='filter' v-click-outside='closeDropdown'>
    <form class='default-filters'>
      <div v-for='filter in filterList' :key='filter' class='btn-group dropdown form-group' role='group' aria-expanded='false' ref='dropdown'>
        <button aria-expanded='false' aria-haspopup='true' data-toggle='dropdown'>
          {{ $t('root.filters.' + filter) }}
          <i class='fas fa-sort-down' aria-hidden='true'></i>
        </button>

        <div class='dropdown-menu'>
          <component :is="'filter-items-by-' + filter" @cancel='closeDropdown' />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import _filter_items_by_contact from './_filter_by_contact'
import _filter_items_by_tag from './_filter_by_tag'
import _filter_items_by_email from './_filter_by_email'
import _filter_items_by_checklist_progress from './_filter_by_checklist_progress'
import _filter_items_by_company from './_filter_by_company'
import _filter_items_by_contact_data_status from './_filter_by_contact_data_status'

export default {
  components: {
    'filter-items-by-contact': _filter_items_by_contact,
    'filter-items-by-tag': _filter_items_by_tag,
    'filter-items-by-email': _filter_items_by_email,
    'filter-items-by-contact_data_checklist_progress': _filter_items_by_checklist_progress,
    'filter-items-by-company': _filter_items_by_company,
    'filter-items-by-contact_data_status': _filter_items_by_contact_data_status,
  },
  mounted() {
    $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
      if (!this.isClosable)
        return false

      this.isClosable = false
      return true
    })
  },
  data() {
    return {
      isClosable: false,
    }
  },
  computed: {
    filterList() {
      return Object.freeze(['contact', 'contact_data_checklist_progress', 'tag', 'contact_data_status', 'company', 'email'])
    },
  },
  methods: {
    closeDropdown() {
      this.isClosable = true
    },
  },
}
</script>

<style lang='sass' scoped>
.filter
  display: flex
  margin-top: 10px
  .default-filters
    .dropdown
      > button
        background: none
        border: none
  .form-group
    margin-bottom: 0
    margin-right: 15px
  .dropdown-menu
    li
      color: #686868
      font-weight: 500
      padding-bottom: 5px
      a
        color: #686868
        font-weight: 500
    select
      border: 1px solid #ccc
      border-radius: 3px
      color: #686868
      font-weight: 500
      width: 100%
    label
      margin-bottom: 0
      padding: 5px 0 0
</style>
